<template>
    <div class="report-summary">
        <div v-for="(app, name) in apps">
            <h6 class="font-weight-bold my-3">Application Engagement: {{ name }}</h6>
            <div class="d-flex flex-row justify-content-center mb-3">
                <counter v-bind:to="app.active_users.all" label="Current Active Users"></counter>
                <counter v-bind:to="app.active_users.month" label="Total Registrations"></counter>
                <counter v-bind:to="app.active_users.active" label="Registrations This Month"></counter>
            </div>
            <div class="d-flex flex-row justify-content-center mb-3">
                <counter v-bind:to="app.banner_link_clicks.all" label="Application Banner Clicks"></counter>
                <counter v-bind:to="app.banner_link_clicks.month" label="Clicks This Month"></counter>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportApps",
        props: ['apps']
    }
</script>

<style scoped>

</style>
